import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

export default function About() {
  const { selectedTeam, teamColors } = useTheme();
  const primary = teamColors?.primary || '#0ea5e9';
  const secondary = teamColors?.secondary || '#f97316';
  return (
    <div className="min-h-screen pt-20 bg-gray-50"
      style={{
        background: selectedTeam
          ? `linear-gradient(135deg, ${primary} 0%, ${secondary} 50%, ${primary} 100%)`
          : undefined
      }}
    >
      {/* Hero */}
      <section className="py-20 text-white" style={{ background: `linear-gradient(135deg, ${primary} 0%, ${secondary} 100%)`, position: 'relative' }}>
        <div className="absolute inset-0 bg-black opacity-30"></div>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative">
          <h1 className="text-4xl md:text-6xl font-extrabold mb-4">About 40 Bags</h1>
          <p className="text-lg md:text-xl max-w-3xl mx-auto" style={{ color: 'rgba(255,255,255,0.85)' }}>Twenty years. Same friends. Same game. Same traditions. New mission.</p>
        </div>
      </section>

      {/* Story */}
      <section className="py-16" style={{ background: 'rgba(255,255,255,0.9)' }}>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mx-auto text-gray-800 leading-relaxed space-y-6 text-xl">
            <p>
              <strong>40 Bags</strong> started the way the best traditions do—<strong>organically</strong>. <strong>Four friends</strong> have been meeting up for the
              same college football game <strong>every year</strong> for the last two decades. They <strong>never miss it</strong>. Tailgates, player
              walks, band routes, the must-visit restaurants, the post-game rituals—over the years, they learned the
              rhythms that turn a game trip into a <strong>story you tell for years</strong>.
            </p>
            <p>
              When they started <strong>helping other people</strong> plan their trips—where to park, what time to arrive, where to stay,
              which tickets to grab, and how to make the most of the traditions—friends kept saying the same thing:
              <strong> “You should turn this into something.”</strong> The only problem? They couldn’t think of a name. <strong>“We’re just
              four d-bags trying to help people,”</strong> one of them joked. And then it clicked: <strong>40 Bags</strong>.
            </p>
            <p>
              Today, <strong>40 Bags</strong> exists to make football travel <strong>easy, memorable, and authentic</strong>. We combine <strong>live schedules</strong>{' '}
              with <strong>curated guidance</strong> and <strong>trusted partners</strong>—so you can focus on the good stuff: <strong>the people, the place, and the
              tradition</strong>.
            </p>
          </div>

          <div className="mt-12 md:mt-16 lg:mt-20">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">The Founders</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
              {([
                { name: 'Joe', image: '/images/owners/owner-1.jpg' },
                { name: 'Bobby', image: '/images/owners/owner-2.jpg' },
                { name: 'Matt', image: '/images/owners/owner-3.jpg' },
                { name: 'Phil', image: '/images/owners/owner-4.jpg' }
              ]).map((owner) => (
                <div key={owner.image} className="card bg-white rounded-xl overflow-hidden border border-gray-200">
                  <img
                    src={owner.image}
                    alt={owner.name}
                    className="w-full h-40 object-cover"
                    loading="lazy"
                    onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = '/images/owner-fallback.svg'; }}
                  />
                  <div className="p-4 text-center">
                    <p className="text-gray-900 font-semibold">{owner.name}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-12 md:mt-16 lg:mt-20 border-t border-gray-200 pt-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact Us</h2>
            <address className="not-italic text-lg text-gray-800 leading-relaxed">
              <p className="font-semibold">40 Bags Entertainment Inc.</p>
              <p>11341 NW 52ND Ln</p>
              <p>Doral, Florida 33178-3510</p>
              <p>United States</p>
            </address>
          </div>
        </div>
      </section>
    </div>
  );
}


